import { getLiquidacionesAutorizados, getLiquidacionesAutorizadosGrupo } from "../services/serviceViaje";
import { FormatoFecha } from "./../utils/FormatFecha"
import { getDocuemtVoucherGrupalCompra } from "../services/documentosService";
const dataInicial = {
    liquidaciones: [],
    total: 0,
    fechaInicio: FormatoFecha({date: new Date(), formato: "MMddyyyy"}),
    fechaFinal: FormatoFecha({date: new Date(), formato: "MMddyyyy"}),
    pagina: 0,
    registroPagina: 10,
    exito: 0,
    grupo: {},
    grupos: [],
}
const GET_LIQUIDACIONES_AUTH_ALL = "GET_LIQUIDACIONES_AUTH_ALL"
const GET_LIQUIDACIONES_AUTH_BUSQUEDA_ALL = "GET_LIQUIDACIONES_AUTH_BUSQUEDA_ALL"
const GET_LIQUIDACIONES_AUTH_REGISTROS_PAGINA = "GET_LIQUIDACIONES_AUTH_REGISTROS_PAGINA"
const GET_LIQUIDACIONES_AUTH_PAGINA = "GET_LIQUIDACIONES_AUTH_PAGINA"
const GET_LIQUIDACIONES_AUTH_GRUPO = "GET_LIQUIDACIONES_AUTH_GRUPO"
const GET_LIQUIDACIONES_DOWLOAD = "GET_LIQUIDACIONES_DOWLOAD"
const CLEAR_LIQUIDACIONES_AUTH_STATE = "CLEAR_LIQUIDACIONES_AUTH_STATE"
export default function liquidacionesAutorizadasReducer(state = dataInicial, action) {
    switch (action.type) {
        case GET_LIQUIDACIONES_DOWLOAD:
            return {
                ...state,
                exito: action.payload.exito
            }
        case GET_LIQUIDACIONES_AUTH_GRUPO:
            return {
                ...state,
                grupo: action.payload.grupo,
                grupos: action.payload.grupos
            }
        case GET_LIQUIDACIONES_AUTH_PAGINA:
            return {
                ...state,
                liquidaciones: action.payload.liquidaciones,
                total: action.payload.total,
                pagina: action.payload.pagina,
            }
        case GET_LIQUIDACIONES_AUTH_REGISTROS_PAGINA:
            return {
                ...state,
                liquidaciones: action.payload.liquidaciones,
                total: action.payload.total,
                registroPagina: action.payload.registroPagina
            }
        case GET_LIQUIDACIONES_AUTH_BUSQUEDA_ALL:
            return {
                ...state,
                liquidaciones: action.payload.liquidaciones,
                total: action.payload.total,
                fechaInicio: action.payload.fechaInicio,
                fechaFinal: action.payload.fechaFinal,
                pagina: action.payload.pagina,
                registroPagina: action.payload.registroPagina
            }
        case GET_LIQUIDACIONES_AUTH_ALL:
            return {
                ...state,
                liquidaciones: action.payload.liquidaciones,
                total: action.payload.total
            };
        case CLEAR_LIQUIDACIONES_AUTH_STATE:
            return {
                ...state,
                liquidaciones: action.payload.liquidaciones
            }
        default:
            return state;
    }
}
export const obtenerVoucherDowloadGrupoAuthAction = ({idPagoGrupal}) => async (dispatch, getSate) => {
    return await getDocuemtVoucherGrupalCompra({idPagoGrupal}).then(Response => {
        dispatch({
            type: GET_LIQUIDACIONES_DOWLOAD,
            payload: {
                exito: 1
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerliquidacionesAuthAction = () => async (dispatch, getSate) => {
    const { fechaInicio, fechaFinal, pagina, registroPagina } = getSate().liquidacionesAuth
    return await getLiquidacionesAutorizados({ FechaInicio: fechaInicio, FechaFin: fechaFinal, Pagina: pagina + 1, Registros: registroPagina }).then(Response => {
        dispatch({
            type: GET_LIQUIDACIONES_AUTH_ALL,
            payload: {
                liquidaciones: Response.listGrupoAereo,
                total: Response.tamanio
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerliquidacionesAuthBusquedaAction = ({ FechaInicio, FechaFin }) => async (dispatch, getSate) => {
    return await getLiquidacionesAutorizados({ FechaInicio, FechaFin ,Pagina: dataInicial.pagina + 1, Registros: dataInicial.registroPagina }).then(Response => {
        dispatch({
            type: GET_LIQUIDACIONES_AUTH_BUSQUEDA_ALL,
            payload: {
                liquidaciones: Response.listGrupoAereo,
                total: Response.tamanio,
                fechaInicio: FechaInicio,
                fechaFinal: FechaFin,
                pagina: dataInicial.pagina,
                registroPagina: dataInicial.registroPagina,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerliquidacionesAuthRegistrosAction = ({ Registros }) => async (dispatch, getSate) => {
    const { fechaInicio, fechaFinal, pagina } = getSate().liquidacionesAuth
    return await getLiquidacionesAutorizados({ FechaInicio: fechaInicio, FechaFin: fechaFinal, Pagina: pagina + 1, Registros }).then(Response => {
        dispatch({
            type: GET_LIQUIDACIONES_AUTH_REGISTROS_PAGINA,
            payload: {
                liquidaciones: Response.listGrupoAereo,
                total: Response.tamanio,
                registroPagina: Registros,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerliquidacionesAuthPaginaAction = ({ Pagina }) => async (dispatch, getSate) => {
    const { fechaInicio, fechaFinal, registroPagina } = getSate().liquidacionesAuth
    return await getLiquidacionesAutorizados({ FechaInicio: fechaInicio, FechaFin: fechaFinal, Pagina: Pagina + 1, Registros: registroPagina }).then(Response => {
        dispatch({
            type: GET_LIQUIDACIONES_AUTH_PAGINA,
            payload: {
                liquidaciones: Response.listGrupoAereo,
                total: Response.tamanio,
                pagina: Pagina,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerliquidacionesAuthGrupoAction = ({ IdPagoGrupal }) => async (dispatch, getSate) => {
    return await getLiquidacionesAutorizadosGrupo({ IdPagoGrupal}).then(Response => {
        dispatch({
            type: GET_LIQUIDACIONES_AUTH_GRUPO,
            payload: {
                grupo: { ...Response, FechaViaje: Response.Fecha_Viaje, PlazaAereo: Response.totalCumplido, PlazaTotal: Response.totalPlazas, lViajeVompra: [] },
                grupos: Response,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const clearState = () => (dispatch) => {
    dispatch({
        type: CLEAR_LIQUIDACIONES_AUTH_STATE,
        payload: {
            dataInicial,
        },
    });
}